/**
 * Merkezi Audio Manager
 * 
 * Tüm bildirim seslerini tek bir yerde oluşturur.
 * Bu sayede aynı ses dosyası birden fazla context'te kullanılsa bile
 * tarayıcı sadece bir kez network isteği yapar (206 Partial Content tekrarı önlenir).
 */
import GeneralNotificationSoundFile from "../components/General/GeneralNotificationSound.mp3";
import WhatsappNotificationSoundFile from "../components/Whatsapp/Notification_Sound.mp3";
import TelegramNotificationSoundFile from "../components/TelegramBigScreen/Notification_Sound.mp3";

// Singleton Audio instance'ları - uygulama boyunca bir kez oluşturulur
export const generalNotificationSound = new Audio(GeneralNotificationSoundFile);
export const whatsappNotificationSound = new Audio(WhatsappNotificationSoundFile);
export const telegramNotificationSound = new Audio(TelegramNotificationSoundFile);
